var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2201_3800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.2104 88.041H15.7899C11.8088 88.041 8.43517 85.1098 7.87929 81.1677L3.04541 46.8914H87.9549L83.1211 81.1677C82.5652 85.1098 79.1916 88.041 75.2104 88.041Z",
    fill: "url(#paint0_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1922 83.57C33.6271 83.57 30.6831 80.7847 30.4858 77.225L29.677 62.6363C29.4637 58.7866 32.5277 55.5477 36.3834 55.5477H37.1064C40.8005 55.5477 43.8014 58.5309 43.8231 62.225L43.909 76.8136C43.9309 80.5387 40.9173 83.57 37.1922 83.57Z",
    fill: "url(#paint1_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3233 62.6364L60.5145 77.2251C60.3172 80.7847 57.3731 83.5701 53.8081 83.5701C50.0831 83.5701 47.0695 80.5387 47.0914 76.8137L47.1774 62.2251C47.1991 58.531 50.2 55.5478 53.894 55.5478H54.617C58.4725 55.5478 61.5368 58.7866 61.3233 62.6364Z",
    fill: "url(#paint2_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1933 83.5699C15.837 83.5699 13.0087 81.0651 12.603 77.7335L10.8074 62.9894C10.3257 59.0336 13.4129 55.5478 17.3977 55.5478H18.1241C21.6044 55.5478 24.494 58.2354 24.7456 61.7066L25.8149 76.4507C26.0939 80.2964 23.049 83.5699 19.1933 83.5699Z",
    fill: "url(#paint3_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1926 62.9894L78.3971 77.7335C77.9913 81.0651 75.1631 83.5699 71.8068 83.5699C67.9511 83.5699 64.9062 80.2964 65.1852 76.4507L66.2545 61.7066C66.5061 58.2354 69.3958 55.5478 72.876 55.5478H73.6024C77.5874 55.5478 80.6744 59.0338 80.1926 62.9894Z",
    fill: "url(#paint4_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7017 51.5453L40.1974 88.041H75.2104C79.1916 88.041 82.5652 85.1098 83.1211 81.1677L87.9549 46.8914H3.04541L3.7017 51.5453Z",
    fill: "url(#paint5_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4153 51.4285H3.58471C1.88106 51.4285 0.5 50.0474 0.5 48.3438V44.6786C0.5 42.975 1.88106 41.5939 3.58471 41.5939H87.4153C89.1189 41.5939 90.5 42.975 90.5 44.6786V48.3438C90.5 50.0474 89.1189 51.4285 87.4153 51.4285Z",
    fill: "url(#paint6_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 51C23.9853 51 26 48.9853 26 46.5C26 44.0147 23.9853 42 21.5 42C19.0147 42 17 44.0147 17 46.5C17 48.9853 19.0147 51 21.5 51Z",
    fill: "url(#paint7_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 50C23.433 50 25 48.433 25 46.5C25 44.567 23.433 43 21.5 43C19.567 43 18 44.567 18 46.5C18 48.433 19.567 50 21.5 50Z",
    fill: "url(#paint8_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2412 42H21.4662L20.6224 43.5902L19.2221 46.2289C18.7886 47.0457 19.0116 48.0033 19.7001 48.5883L23.3707 52H37L26.2412 42Z",
    fill: "url(#paint9_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1787 49C20.8549 49 20.5263 48.9276 20.2162 48.7744C19.1364 48.2417 18.6928 46.9342 19.2253 45.8542L31.8645 20.2167C32.3972 19.1365 33.704 18.6926 34.7838 19.2255C35.8636 19.7582 36.3072 21.0658 35.7746 22.1458L23.1355 47.7833C22.7558 48.5533 21.9827 49 21.1787 49Z",
    fill: "url(#paint10_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 51C70.9853 51 73 48.9853 73 46.5C73 44.0147 70.9853 42 68.5 42C66.0147 42 64 44.0147 64 46.5C64 48.9853 66.0147 51 68.5 51Z",
    fill: "url(#paint11_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 51.9587L72.2697 44.9688C72.0305 44.6703 71.7402 44.4078 71.41 44.1915L68.9864 42H64L65.8385 45.2753L67.3236 47.9982C67.4586 48.2458 67.6435 48.456 67.8609 48.6257L71.5925 52H79.3009C79.538 51.9999 79.7709 51.9848 80 51.9587Z",
    fill: "url(#paint12_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 50C70.433 50 72 48.433 72 46.5C72 44.567 70.433 43 68.5 43C66.567 43 65 44.567 65 46.5C65 48.433 66.567 50 68.5 50Z",
    fill: "url(#paint13_linear_2201_3800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8213 49C69.1452 49 69.4737 48.9276 69.7838 48.7744C70.8636 48.2417 71.3072 46.9342 70.7747 45.8542L58.1354 20.2167C57.6028 19.1365 56.296 18.6926 55.2162 19.2255C54.1364 19.7582 53.6928 21.0658 54.2254 22.1458L66.8646 47.7833C67.2442 48.5533 68.0173 49 68.8213 49Z",
    fill: "url(#paint14_linear_2201_3800)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2201_3800",
    x1: 46.4833,
    y1: 54.9822,
    x2: 52.8779,
    y2: 95.3479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2201_3800",
    x1: 42.8731,
    y1: 69.2924,
    x2: 24.6995,
    y2: 70.0883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2201_3800",
    x1: 60.1525,
    y1: 69.5589,
    x2: 43.409,
    y2: 69.5589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2201_3800",
    x1: 27.533,
    y1: 68.659,
    x2: 7.10826,
    y2: 70.6486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2201_3800",
    x1: 80.6155,
    y1: 69.736,
    x2: 63.6397,
    y2: 69.3559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2201_3800",
    x1: 48.2531,
    y1: 68.4289,
    x2: 44.7916,
    y2: 41.3476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2201_3800",
    x1: 45.4074,
    y1: 44.6578,
    x2: 45.7128,
    y2: 50.7663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2201_3800",
    x1: 22.4572,
    y1: 47.4584,
    x2: 15.8384,
    y2: 40.8396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2201_3800",
    x1: 20.7547,
    y1: 45.756,
    x2: 25.9042,
    y2: 50.9042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2201_3800",
    x1: 30.2407,
    y1: 52.054,
    x2: 11.1133,
    y2: 31.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE3F45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2201_3800",
    x1: 26.1558,
    y1: 33.2381,
    x2: 29.3898,
    y2: 35.0731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2201_3800",
    x1: 67.5413,
    y1: 47.4584,
    x2: 74.1601,
    y2: 40.8396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2201_3800",
    x1: 75.4953,
    y1: 51.6821,
    x2: 58.7769,
    y2: 33.1929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE3F45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE3F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2201_3800",
    x1: 69.2439,
    y1: 45.756,
    x2: 64.0945,
    y2: 50.9042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C3C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2201_3800",
    x1: 63.8427,
    y1: 33.2381,
    x2: 60.6087,
    y2: 35.0731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF465"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2201_3800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.d9d1432e075d2a1b865d144820709092.svg";
export { ForwardRef as ReactComponent };